export default __webpack_public_path__ + "static/052-0d367c0ea8684d2a5b5e4db3301a434a.jpg";